import React from 'react'
import {FormattedMessage} from 'react-intl'
import {
    Box,
    DrawerCloseButton,
    Flex,
    Text
} from '@salesforce/retail-react-app/app/components/shared/ui'
import SelectedRefinements from './selected-refinements'

const getSelectedFilterCount = (selectedRefinements) => {
    let count = 0

    for (const key in selectedRefinements) {
        if (key === 'cgid' || key === 'htype') continue

        const values = selectedRefinements[key]?.split('|')
        count += values.length
    }

    return count
}

const SelectedFiltersHeader = ({productSearchResult, toggleFilter, resetFilters}) => {
    const selectedRefinements = productSearchResult?.selectedRefinements || {}
    const numberOfSelectedFilters = getSelectedFilterCount(selectedRefinements)

    return (
        <Box color="black" fontSize="xs" fontWeight="normal" textTransform="none">
            <Flex align="center" justify="space-between">
                <Text>
                    {numberOfSelectedFilters > 0 ? (
                        <FormattedMessage
                            id="selected_filters_header.filters_selected"
                            defaultMessage="{count, plural, one {# filter selected} other {# filters selected}}"
                            values={{count: numberOfSelectedFilters}}
                        />
                    ) : (
                        <FormattedMessage
                            id="selected_filters_header.none_selected"
                            defaultMessage="No filters selected"
                        />
                    )}
                </Text>
                <DrawerCloseButton position="static" />
            </Flex>

            <SelectedRefinements
                filters={productSearchResult?.refinements}
                toggleFilter={toggleFilter}
                handleReset={resetFilters}
                selectedFilterValues={selectedRefinements}
                spacing={{base: 1, lg: '10px'}}
            />
        </Box>
    )
}

export default SelectedFiltersHeader
